import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import TestnetFaucet from './pages/Faucet.js';


function App() {
  return (
    <Router>
      
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/testnetfaucet" element={<TestnetFaucet />} />
        </Routes>
      
    </Router>
  );
}

export default App;